/* eslint-disable */
import {
  Component,
  Renderer,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Location } from '@angular/common';
import { ModalService } from '../../../shared/services/modal.service';
import { Router } from '@angular/router';
import { ApplicationActions } from '../../../actions/application.actions';
import { ApplicationProxyService } from '../../../shared/services/applicationproxy.service';
import { FlowManagerService } from '../../../shared/services/flowmanager.service';
import { DomInjectorService } from '../../../shared/services/domInjector.service.js';
import { TimeOutService } from '../../../shared/services/timeout.service';
import { DTMService } from '../../../shared/services/dtm.service';

@Component({
  selector: 'modal',
  template: require('./modal.component.html'),
  styles: [require('./modal.component.scss')],
})
export class ModalComponent {
  @ViewChild('focusItem') focusItem;

  capitalize = 'https://app.hicapitalize.com/p/ally';

  constructor(
    appProxy: ApplicationProxyService,
    modal: ModalService,
    location: Location,
    router: Router,
    appActions: ApplicationActions,
    fm: FlowManagerService,
    dtm: DTMService,
    di: DomInjectorService,
    timeoutService: TimeOutService,
    renderer: Renderer,
    elementRef: ElementRef
  ) {
    this.modalService = modal;
    this.location = location;
    this.router = router;
    this.appActions = appActions;
    this.appProxy = appProxy;
    this.fm = fm;
    this.dtm = dtm;
    this.di = di;
    this.timeoutService = timeoutService;
    this.timer = 59;
    this.sipc = 'http://sipc.org/';
    this.sipc_1 = 'http://www.sipc.org/for-investors/what-sipc-protects';
    this.finra = 'http://www.finra.org/';
    this.allyContentDisclosurepdf ='https://www.ally.com/content/dam/pdf/invest/market_data_disclosure_and_subscriber_agreements.pdf';
    this.nfa = 'https://www.nfa.futures.org';
    this.nmlsConsumer = 'https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/181005';
    this.securitiesDisclosure ='https://www.ally.com/invest/disclosures/#securities';
    this.finra_brokercheck = 'https://brokercheck.finra.org/firm/summary/136131';
    this.crso = 'https://brokercheck.finra.org/firm/summary/136131';
    this.ole = 'https://www.ally.com/enroll';
    this.optionsBrouchre =
      'https://www.theocc.com/Company-Information/Documents-and-Archives/Options-Disclosure-Document';
    this.finraRule2165 =
      'https://www.finra.org/rules-guidance/rulebooks/finra-rules/2165';

    this.modalSubscription = this.modalService.closeEvent.subscribe((event) =>
      this.close(event)
    );
    this.modalSubscriptionRefresh = this.modalService.refreshEvent.subscribe(
      (event) => this.refresh(event)
    );
    this.modalTimer = this.modalService.timerEvent.subscribe(
      (v) => (this.timer = v)
    );
    this.el = elementRef;
    this._renderer = renderer;
  }

  ngOnDestroy() {
    this.modalService.clearData();
    this.modalSubscription.unsubscribe();
    this.modalSubscriptionRefresh.unsubscribe();
    this.modalTimer.unsubscribe();
    this.resetDOMForClose();
  }

  ngOnInit() {
    this.modalObj = this.modalService.getModalData();
    // If modalObj body is an array, break it into individual <p>s.
    if (Array.isArray(this.modalObj.body)) {
      this.modalObj.body = this.modalObj.body.map((part) => `<p>${part}</p>`).join('');
    }
    this.isCitizenship = this.modalObj?.modalClass?.includes('citizenship');
    this.showFooter = this.modalObj.buttons
      && this.modalObj.buttons.length
      || !this.isCitizenship;
    this.dtm.triggerModalViewEvent(this.modalObj.title);

    if (this.modalObj.modalType === undefined) {
      this.router.navigate([{ outlets: { aux: null, timeout: null } }], {
        queryParamsHandling: 'preserve',
      });
    }

    try {
      const modal = document.querySelector('.modal');
      this.lastFocused = document.activeElement;
      this.tabIndexRestoreFunctions = Array.prototype.filter // get tabable items which aren't children of our modal
        .call(
          document.all,
          (o) => o.tabIndex > -1 && !this._isDescendant(modal, o)
        )
        // iterate over those items, set the tabIndex to -1, and
        // return a function to restore tabIndex
        .map((obj) => {
          const oldTabIndex = obj.tabIndex;
          obj.tabIndex = -1;
          return function () {
            obj.tabIndex = oldTabIndex;
          };
        });
    } catch (e) {
      console.log('MODAL ERROR', e);
    }

    const closeableModalTypes = [
      'closable',
      'closable-fund',
      'generic',
      'cashVested',
      'historical',
      'uploadLater',
    ];

    if (closeableModalTypes.includes(this.modalObj.modalType)) {
      document
        .getElementById('modal_overlay')
        .addEventListener('click', (e) => this.close(e));
    }
  }

  ngAfterViewInit() {
    if (this.modalObj.modalType === 'closable-fund') {
      Array.from(document.querySelectorAll('.modal a')).forEach((button) => {
        let route = button.href.split('/');
        route = route[route.length - 1];
        button.onclick = (e) => {
          e.preventDefault();
          this.router.navigate([{ outlets: { primary: route, aux: null } }]);
        };
      });
    }
    if (this.modalObj.modalType !== undefined) {
      document.body.appendChild(this.el.nativeElement);
      this.modifyDOMForDisplay();
      if (this.focusItem) {
        setTimeout(() => {
          this.focusItem.nativeElement.focus();
        }, 1000);
      }
    }
  }

  close(route) {
    // restore tabs
    if (this.tabIndexRestoreFunctions) {
      this.tabIndexRestoreFunctions.forEach((f) => f());
    }
    this.tabIndexRestoreFunctions = null;
    // restore focus
    if (this.lastFocused) {
      this.lastFocused.focus();
    }

    if (route !== undefined && typeof route === 'string') {
      if (route === 'timeout') {
        this.router.navigate([{ outlets: { timeout: null } }], {
          queryParamsHandling: 'preserve',
        });
      } else if (route === 'timedout') {
        this.router.navigate([
          { outlets: { primary: 'timed-out', timeout: null, aux: null } },
        ]);
      } else {
        this.router.navigate([{ outlets: { primary: route, aux: null } }], {
          queryParamsHandling: 'preserve',
        });
      }
    } else {
      this.router.navigate([{ outlets: { aux: null } }], {
        queryParamsHandling: 'preserve',
      });
    }
    this.resetDOMForClose();
  }

  refresh(data) {
    this.modalObj = data;
  }

  async action(actionType) {
    switch (actionType) {
      case 'deleteBen':
        this.close();
        this.modalService.callCb();
        break;
      case 'close':
        this.close();
        break;
      case 'leaveApp':
        await this.appProxy.clearSession();
        this.fm.refreshApp();
        break;
      case 'extendTimeout':
        this.timeoutService.modalClosed();
        this.close('timeout');
        break;
      case 'finra':
        window.open(this.finra, '_blank');
        this.close();
        break;
      case 'finraRule2165':
        window.open(this.finraRule2165, '_blank');
        this.close();
        break;
      case 'sipc':
        window.open(this.sipc, '_blank');
        this.close();
        break;
      case 'sipc_1':
        window.open(this.sipc_1, '_blank');
        this.close();
        break;
      case 'nfa':
        window.open(this.nfa, '_blank');
        this.close();
        break;
      case 'finra_brokercheck':
        window.open(this.finra_brokercheck, '_blank');
        this.close();
        break;
      case 'crso':
        window.open(this.crso, '_blank');
        this.close();
        break;
      case 'ole':
        window.open(this.ole, '_blank');
        this.close();
        break;
      case 'optionsBrouchre':
        window.open(this.optionsBrouchre, '_blank');
        this.close();
        break;
      case 'nmlsConsumer':
        window.open(this.nmlsConsumer, '_blank');
        this.close();
        break;
      case 'allyContentDisclosurepdf':
        window.open(this.allyContentDisclosurepdf, '_blank');
        this.close();
        break;
      case 'securitiesDisclosure':
        window.open(this.securitiesDisclosure, '_blank');
        this.close();
        break;
      case 'capitalize':
        window.open(this.capitalize, '_blank');
        break;
      default:
        console.log('Default switch touched', actionType);
        break;
    }
  }

  _isDescendant(ancestor, descendant) {
    do {
      if (descendant === ancestor) return true;
    } while ((descendant = descendant.parentNode));
    return false;
  }

  login() {
    window.location.href =
      'https://secure.ally.com/#/products-and-rates/self-directed-trading/';
  }

  forgotUsername() {
    this.refresh({
      modalType: 'closable',
      fukTopRight: 'true',
      fukTopRightID: 'Modal_Close',
      fukTopRightClass: 'modal-top-right-close-btn',
      modalClass: 'forgot-username-modal',
      title: 'Forgot your username?',
      body: '<p><b>Bank</b> 1-877-247-2559<br><b>Invest</b> 1-855-880-2559</p>',
      buttons: [],
    });
  }

  _generateReplayObject() {
    let pathname = document.location.pathname.split('/');
    pathname = pathname[1];
    const replayUrl = `${document.location.origin}/${pathname}`;
    const appType = this.fm.getAppType() || 'tks';
    const replayObject = { Verb: 'GET', Url: `${replayUrl}?app=${appType}` };
    return replayObject;
  }

  _difFundingMethod(route) {
    if (route !== 'fund-by-broker') {
      this.fm.resetAcats();
    }
    this.router.navigate(['', { outlets: { primary: route, aux: null } }]);
  }

  modifyDOMForDisplay() {
    const root = document.getElementsByTagName('root')[0];
    const body = document.getElementsByTagName('body')[0];
    if (root) this._renderer.setElementAttribute(root, 'aria-hidden', true);
    if (body) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      body.style.overflow = 'hidden';
      body.style.paddingRight = scrollbarWidth + 'px';
    }
  }

  resetDOMForClose() {
    const root = document.getElementsByTagName('root')[0];
    const body = document.getElementsByTagName('body')[0];
    if (root) this._renderer.setElementAttribute(root, 'aria-hidden', false);
    if (body) {
      body.style.overflow = 'initial';
      body.style.paddingRight = '0';
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.modalObj.modalType === 'closable') {
      this.close();
    }
  }
}
